import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { CueHistory } from 'src/app/models/fincas/cue.model';
import { CueHistoryPresenter } from '../../presenters/cue-history.presenter';
import { CueStatusPresenter } from '../../presenters/cue-status.presenter';

/** Guides the user through selective retry after a partial or failed CUE response. */
@Component({
  selector: 'app-cue-retry-actions',
  templateUrl: './cue-retry-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CueRetryActionsComponent {
  @Input()
  public hasPendingCue = false;

  @Input()
  public pendingTaskCount = 0;

  @Input()
  public showSpinner = false;

  @Input()
  public statusCue: CueHistory | null = null;

  @Output()
  public readonly acceptedReviewRequested = new EventEmitter<void>();

  @Output()
  public readonly problemReviewRequested = new EventEmitter<void>();

  @Output()
  public readonly retryCorrected = new EventEmitter<void>();

  public get acceptedCount(): number {
    return this.statusCue ? CueHistoryPresenter.acceptedCount(this.statusCue) : 0;
  }

  public get canRetry(): boolean {
    return this.shouldShow && this.pendingTaskCount > 0 && !this.showSpinner;
  }

  public get description(): string {
    if (this.pendingTaskCount > 0) {
      return 'Hay actividades corregidas o pendientes listas para reintentar. Las ya aceptadas no se volverán a enviar.';
    }

    return 'Corrige primero las actividades con problemas. Cuando vuelvan a estar listas aparecerá el reintento.';
  }

  public get pendingReviewCount(): number {
    return this.statusCue ? CueHistoryPresenter.pendingCount(this.statusCue) : 0;
  }

  public get problemCount(): number {
    return this.statusCue ? CueHistoryPresenter.rejectedCount(this.statusCue) : 0;
  }

  public get shouldShow(): boolean {
    return CueStatusPresenter.shouldShowRetryActions(this.statusCue, this.hasPendingCue);
  }

  public requestAcceptedReview(): void {
    this.acceptedReviewRequested.emit();
  }

  public requestProblemReview(): void {
    this.problemReviewRequested.emit();
  }

  public retry(): void {
    if (!this.canRetry) {
      return;
    }

    this.retryCorrected.emit();
  }
}
